module.exports = __webpack_public_path__ + "static/media/canari_logo_halloween.e10e61c2.png";